// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OSAr","label":"styles_label__1GzPJ"};